<template>
    <div class="inner">
      <ul>
        <li v-for="(item, index) in viewList" :class="[!index && update ? 'push' : '']" :key="index">
          <div class="user">
            <img class="level" :src="`/refer/img/level/lv${item.level}.png`" alt="level" />
            <a class="nick" href="javascript:;" @click="openPopup(item.nickname)">{{ item.nickname }}</a>
          </div>
          <span class="gold">{{ numberWithComma(item.AmountResult.toString()) }}</span>
        </li>
      </ul>
    </div>
</template>

<script>
  export default {
    name: "live-winners",
    props:['winners'],
    data() {
      return {
        viewList: [],
        pushList: [],
        update: false,
        pushCount: 9,
      }
    },
    methods: {
      numberWithComma(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      openPopup(name) {
        window.open(`/mypage/namecard.php?nickname=${name}`, "", "width=500,height=600")
      },
    },
    created() {
      this.viewList = this.winners.slice(0, 30)
      this.defaultList = this.winners
    },
    async mounted() {
      window.winnersList =  setInterval(() => {
        if (this.pushCount === 50) {
          this.pushCount = 0
        }
        const pushItem = this.defaultList[this.pushCount++]
        this.update = true
        this.viewList = [pushItem, ...this.viewList]
        setTimeout(() => {
          this.update = false
        }, 1000)
      }, 3000)
    },
    destroyed() {
      clearInterval(window.winnersList)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/main/live-winners.vue